/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * DashBoard
 * OpenAPI spec version: v2.0.0
 */

export type TaskFunctionType =
  (typeof TaskFunctionType)[keyof typeof TaskFunctionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TaskFunctionType = {
  SUM: 'SUM',
  TOTALIZED: 'TOTALIZED',
  MIN: 'MIN',
  MAX: 'MAX',
  AVG: 'AVG',
  CUMULATIVE: 'CUMULATIVE',
} as const;
